export default function isShown({ open, minLength, showMenu, text, }) {
    if (open || open === false) {
        return open;
    }
    if (text.length < minLength) {
        return false;
    }
    return showMenu;
}
